export function useCollectionsQueries() {
  const queryClient = useQueryClient();
  const { collections: collectionsService } = useApiClient();

  const { fetch: prefetch } = usePrefetch();

  const useListCollectionsQuery = (
    params: {
      limit?: number;
      international?: Ref<boolean | undefined>;
    },
    opts = {}
  ) => {
    return useQuery(
      {
        queryKey: ["collections", params.international?.value],
        queryFn: async () =>
          collectionsService.listCollections({
            limit: params.limit,
            international: params.international?.value,
          }),
        placeholderData: keepPreviousData,
        initialData: prefetch("collections"),
        ...opts,
      },
      queryClient
    );
  };

  const useGetCollectionQuery = (params: { id: string }) => {
    return useQuery(
      {
        queryKey: ["collection", params.id],
        queryFn: () =>
          collectionsService.getCollection({
            id: params.id,
          }),
        initialData: prefetch(`collection_${params.id}`),
      },
      queryClient
    );
  };

  const useListRecommendedCollectionsQuery = (params: { id: string }) => {
    return useQuery(
      {
        queryKey: ["recommendedCollections", params.id],
        queryFn: async () =>
          collectionsService.listRecommendedCollections({
            id: params.id,
          }),
        placeholderData: keepPreviousData,
      },
      queryClient
    );
  };

  const useListFeaturedCollectionsQuery = (
    params: {
      limit?: number;
      international?: Ref<boolean | undefined>;
    },
    opts = {}
  ) => {
    return useQuery(
      {
        queryKey: ["featuredCollections", params.international?.value],
        queryFn: async () =>
          collectionsService.listFeaturedCollections({
            limit: params.limit,
            international: params.international?.value,
          }),
        placeholderData: keepPreviousData,
        initialData: prefetch("featured_collections"),
        ...opts,
      },
      queryClient
    );
  };

  return {
    useListCollectionsQuery,
    useGetCollectionQuery,
    useListRecommendedCollectionsQuery,
    useListFeaturedCollectionsQuery,
  };
}
